/* ---------------------------------------------------------------------------
   Sarvati cart merge, version 7. 20 September 2026.

   In the cart drawer and on the cart page, a stitching or add on line (any
   line carrying the property "Add-on for") is drawn as a detail row under
   the garment it belongs to instead of as a second product, each with its
   own Remove.

   FALL AND EDGING THAT CAME WITH A SIZE. When the garment carries the
   property "Fall & edging: Included", the fall line is not shown as a row
   at all: its price is folded into the stitching row, so she reads
   "Blouse Stitching, size S  $17.99" and never sees a $3 she did not
   choose. Removing that stitching row removes the fall with it. (On the
   checkout page, which is Shopify's, the fall is still its own line; the
   way to lose it there too is to price Blouse Stitching at $17.99 and set
   fallMode to "price" in kit.overrides, so no fall product is added.)

   The garment's own Remove, and its minus button reaching zero, take the
   add ons away FIRST, in one atomic /cart/update.js request, and only then
   let the theme remove the garment, so the drawer never sits on an empty
   list with a stale subtotal. Safety net for anything else: an add on
   whose garment is gone is removed, and quantities are kept equal to the
   garment's. Add on lines are hidden the instant they render, before any
   fetch, so they never flash as products. Prices and the subtotal are
   never touched here.
   --------------------------------------------------------------------------- */
(function () {
  if (window.SarvatiCartMergeReady) return;
  window.SarvatiCartMergeReady = true;

  var CSS =
    '.cart__item.svcm-child{display:none!important}' +
    '.svcm-row{display:grid;grid-template-columns:minmax(0,1fr) auto auto;align-items:baseline;gap:4px 8px;' +
      'margin:6px 0 0;padding:6px 0 0;border-top:1px dashed #e6dfd4;font-size:12px;line-height:1.35;color:#3d3632;max-width:100%}' +
    '.svcm-row > span:first-child{min-width:0;overflow-wrap:anywhere}' +
    '.svcm-row > span:first-child::before{content:"+ ";color:#a77c33}' +
    '.svcm-row b{font-weight:600;color:#1a1a1a;white-space:nowrap;font-variant-numeric:tabular-nums}' +
    '.svcm-row i{font-style:normal;color:#6e645c}' +
    '.svcm-x{appearance:none;background:none;border:0;padding:4px 0 4px 4px;margin:-4px 0;cursor:pointer;font:inherit;' +
      'font-size:11px;letter-spacing:.02em;color:#8a7f76;text-decoration:underline;text-underline-offset:2px;white-space:nowrap}' +
    '.svcm-x:hover{color:#1a1a1a}' +
    '.svcm-x[disabled]{opacity:.5;cursor:default}' +
    '@media screen and (max-width:480px){.svcm-row{grid-template-columns:minmax(0,1fr) auto;font-size:11.5px}' +
      '.svcm-row .svcm-x{grid-column:1 / -1;justify-self:end;padding-top:0;margin-top:-2px}}';

  var style = document.createElement('style');
  style.textContent = CSS;
  document.head.appendChild(style);

  var busy = false, queued = false;
  var lastCart = null;

  function quickHide(scope) {
    var items = (scope && scope.querySelectorAll ? scope : document).querySelectorAll('.cart__item:not(.svcm-child)');
    for (var i = 0; i < items.length; i++) {
      var props = items[i].querySelectorAll('.cart__item--properties');
      for (var j = 0; j < props.length; j++) {
        if (/^\s*Add-on for:/i.test(props[j].textContent)) { items[i].classList.add('svcm-child'); break; }
      }
    }
  }

  function money(cents) {
    var sample = document.querySelector('.cart__price, [data-product-price]');
    var txt = sample ? sample.textContent.trim() : '$0.00';
    var m = txt.match(/^([^\d]*)([\d.,]+)([^\d]*)$/);
    var pre = m ? m[1] : '$', post = m && m[3] ? m[3] : '';
    var n = (cents / 100).toFixed(2).split('.');
    n[0] = n[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return pre + n.join('.') + post;
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); }).catch(function () {});
  }
  function update(updates) { return post('/cart/update.js', { updates: updates }); }
  function change(body) { return post('/cart/change.js', body); }

  function themeRefresh() {
    if (document.body.classList.contains('template-cart')) { location.reload(); return; }
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
    setTimeout(refresh, 600);
  }

  /* pair every add on with its garment; a fall that came with a size is
     folded into the stitching pair rather than shown on its own */
  function pairs(cart) {
    var parents = {}, byGroup = {}, out = [], orphans = [];
    cart.items.forEach(function (it) {
      if (!it.properties || !it.properties['Add-on for']) {
        parents[it.product_title] = parents[it.product_title] || it;
        if (it.properties && it.properties._sv_group) byGroup[it.properties._sv_group] = byGroup[it.properties._sv_group] || it;
      }
    });
    cart.items.forEach(function (it) {
      var p = it.properties && it.properties['Add-on for'];
      if (!p) return;
      /* 27 September 2026: the private group id (set at add-to-cart) wins, so two
         sizes of the same product each keep their own stitching line; the title
         match only serves lines added before the group id existed */
      var g = it.properties._sv_group;
      var parent = (g && byGroup[g]) || (g ? null : parents[p]);
      if (parent) out.push({ child: it, parent: parent, extra: [], cents: it.line_price });
      else orphans.push(it);
    });
    out.forEach(function (x) {
      if (!/stitching/i.test(x.child.product_title || '')) return;
      if (!(x.parent.properties && x.parent.properties['Fall & edging'] === 'Included')) return;
      out.forEach(function (y) {
        if (y.parent === x.parent && /fall/i.test(y.child.product_title || '')) { y.folded = true; x.extra.push(y.child); x.cents += y.child.line_price; }
      });
    });
    return { list: out, orphans: orphans };
  }

  function childrenOf(parentKey) {
    if (!lastCart) return [];
    return pairs(lastCart).list.filter(function (x) { return x.parent.key === parentKey; }).map(function (x) { return x.child; });
  }

  function label(child, parent) {
    var t = (child.product_title || 'Add on').replace(/\s*\((Plus Size|My Measurements)\)\s*/i, ' ').replace(/\s+$/, '');
    var size = parent.properties && (parent.properties['Blouse size'] || parent.properties['Choli size'] || parent.properties['Suit size'] || parent.properties['Lehenga size']);
    if (/stitching/i.test(t) && size) {
      t += /measurement|custom/i.test(size) ? ', custom' : (', size ' + size);
    }
    if (child.variant_title && child.variant_title !== 'Default Title' && !/stitching/i.test(t)) t += ' – ' + child.variant_title;
    return t;
  }

  function removeOne(x, button) {
    button.disabled = true;
    var props = {};
    Object.keys(x.parent.properties || {}).forEach(function (k) { props[k] = x.parent.properties[k]; });
    var gone = [x.child].concat(x.extra);
    var sel = props['Selected add-ons'];
    if (sel) {
      var goneTitles = gone.map(function (c) { return (c.product_title || '').trim(); });
      var keep = sel.split(/,\s*/).filter(function (t) { return goneTitles.indexOf(t.trim()) === -1; });
      if (keep.length) props['Selected add-ons'] = keep.join(', ');
      else delete props['Selected add-ons'];
    }
    if (/stitching/i.test(x.child.product_title || '')) {
      if (props['Blouse size']) props['Blouse size'] = 'Unstitched';
      if (props['Choli size']) props['Choli size'] = 'Unstitched';
      if (props['Blouse stitching']) props['Blouse stitching'] = 'Unstitched';
      if (props['Choli stitching']) props['Choli stitching'] = 'Unstitched';
      if (props['Suit size']) props['Suit size'] = 'Standard size';
      if (props['Suit stitching']) props['Suit stitching'] = 'Standard size';
      if (props['Lehenga size']) props['Lehenga size'] = 'Standard size';
      if (props['Lehenga stitching']) props['Lehenga stitching'] = 'Standard size';
      ['Blouse design', 'Choli design', 'Blouse closure', 'Choli closure', 'Blouse padding', 'Choli padding', 'Fall & edging', 'Height'].forEach(function (k) { delete props[k]; });
    }
    if (/fall/i.test(x.child.product_title || '')) delete props['Fall & edging'];
    var upd = {};
    gone.forEach(function (c) { upd[c.key] = 0; });
    update(upd)
      .then(function () { return change({ id: x.parent.key, quantity: x.parent.quantity, properties: props }); })
      .then(themeRefresh);
  }

  function draw(cart) {
    lastCart = cart;
    var p = pairs(cart);

    var upd = {}, need = false;
    p.orphans.forEach(function (o) { upd[o.key] = 0; need = true; });
    p.list.forEach(function (x) {
      if (x.child.quantity !== x.parent.quantity) { upd[x.child.key] = x.parent.quantity; need = true; }
    });
    if (need) {
      p.orphans.forEach(function (o) {
        document.querySelectorAll('.cart__item[data-key="' + o.key + '"]').forEach(function (c) { c.classList.add('svcm-child'); });
      });
      return update(upd).then(themeRefresh);
    }

    document.querySelectorAll('.svcm-row').forEach(function (r) { r.parentNode.removeChild(r); });
    document.querySelectorAll('.cart__item.svcm-child').forEach(function (r) { r.classList.remove('svcm-child'); });
    quickHide();

    p.list.forEach(function (x) {
      document.querySelectorAll('.cart__item[data-key="' + x.child.key + '"]').forEach(function (c) { c.classList.add('svcm-child'); });
      if (x.folded) return;
      document.querySelectorAll('.cart__item[data-key="' + x.parent.key + '"]').forEach(function (pe) {
        var title = pe.querySelector('.cart__item-title') || pe.querySelector('.cart__item-details') || pe;
        var row = document.createElement('div');
        row.className = 'svcm-row';
        row.dataset.svcmChild = x.child.key;
        var l = document.createElement('span');
        l.textContent = label(x.child, x.parent);
        if (x.child.quantity > 1) {
          var q = document.createElement('i');
          q.textContent = ' × ' + x.child.quantity;
          l.appendChild(q);
        }
        var pr = document.createElement('b');
        pr.textContent = money(x.cents);
        var xb = document.createElement('button');
        xb.type = 'button';
        xb.className = 'svcm-x';
        xb.textContent = 'Remove';
        xb.setAttribute('aria-label', 'Remove ' + label(x.child, x.parent));
        xb.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); removeOne(x, xb); });
        row.appendChild(l);
        row.appendChild(pr);
        row.appendChild(xb);
        title.appendChild(row);
      });
    });
  }

  function refresh() {
    if (busy) { queued = true; return Promise.resolve(); }
    busy = true;
    quickHide();
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
      .then(function (r) { return r.json(); })
      .then(function (cart) { return draw(cart); })
      .catch(function () {})
      .then(function () {
        busy = false;
        if (queued) { queued = false; return refresh(); }
      });
  }

  function takeChildrenThen(el, item, proceed) {
    var kids = childrenOf(item.dataset.key);
    if (!kids.length) { proceed(); return; }
    var upd = {};
    kids.forEach(function (k) { upd[k.key] = 0; });
    kids.forEach(function (k) {
      document.querySelectorAll('.cart__item[data-key="' + k.key + '"]').forEach(function (c) { c.classList.add('svcm-child'); });
    });
    update(upd).then(proceed, proceed);
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var a = t.closest('.cart__remove a, a[href*="/cart/change"][href*="quantity=0"]');
    var minus = t.closest('.js-qty__adjust--minus');
    var el = a || minus;
    if (!el || el.dataset.svcmDone) return;
    var item = el.closest('.cart__item');
    if (!item || item.classList.contains('svcm-child')) return;
    if (minus) {
      var input = item.querySelector('.js-qty__num');
      if (!input || parseInt(input.value, 10) > 1) return;
    }
    if (!childrenOf(item.dataset.key).length) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    takeChildrenThen(el, item, function () {
      el.dataset.svcmDone = '1';
      el.click();
      setTimeout(function () { delete el.dataset.svcmDone; }, 2000);
    });
  }, true);

  var t;
  function schedule(ms) { clearTimeout(t); t = setTimeout(refresh, ms || 100); }
  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      var hit = false;
      for (var i = 0; i < muts.length; i++) {
        var m = muts[i];
        if (m.target && m.target.closest && m.target.closest('.svcm-row')) continue;
        var added = m.addedNodes;
        for (var j = 0; j < added.length; j++) {
          var n = added[j];
          if (n.nodeType !== 1) continue;
          if (n.matches && (n.matches('.cart__item') || n.querySelector('.cart__item'))) { quickHide(n.parentNode || n); hit = true; }
        }
      }
      if (hit) schedule();
    }).observe(document.body, { childList: true, subtree: true });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.js-qty__adjust')) schedule(700);
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches && e.target.matches('.js-qty__num')) schedule(700);
  });
  document.addEventListener('cart:updated', function () { schedule(); });
  document.addEventListener('ajaxProduct:added', function () { schedule(); });
  refresh();
})();